<div mat-dialog-title style="margin:0px;">{{header}}</div> 

    
    <mat-dialog-content>

        <div style="padding: 10px;">
                {{ messageLine1 }}
                <br />
                {{ messageLine2 }}
        </div>

        <!-- <tyl-checkbox [(checked)]="removeArchivedFiles" id="removeArchivedFiles"
        translate name="deleteArchiveFiles">
        Remove archived reports already processed in this batch?
    </tyl-checkbox> -->
            

    </mat-dialog-content>
    
    <mat-dialog-actions>
        <div class="flex-footer-right">
            <tyl-button id="continue" image="next arrow.png" label="Continue" (clickEvent)="continueClick()"></tyl-button>
            <tyl-button id="exit" image="cancel.png" label="Exit" (clickEvent)="exitClick()"></tyl-button>
        </div>
    </mat-dialog-actions>